<!--登陆页-->
<!--<script src="http://res.wx.qq.com/open/js/jweixin-1.4.0.js"></script>-->
<template>
    <div class="onimg" style="padding-top: 150px">
        <img src="logo.png" style="width: 200px;"><br/>
<!--        <button @click="onchange">登陆使用</button>-->
    </div>
</template>

<script>
    import store from '@/store'
    import axios from 'axios'

    const wx = require('weixin-js-sdk')
    export default {
        name: "login",
        data() {
            return {
                winUrl: '',
            }
        },
        methods: {

            getCode() { // 非静默授权，第一次有弹框
                this.code = ''
                var local = window.location.href // 获取页面url
                console.log(local)
                var appid = 'wx35df9038a4f73847'
                //测试号
                // var appid = 'wxb985bc41dfdc879a'
                this.code = this.getUrlCode().code // 截取code
                // console.log(this.code)
                if (this.code == null || this.code === '') { // 如果没有code，则去请求
                    // window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(local)}&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect`
                    window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=https://wxpa.jianchengjt.com&response_type=code&scope=snsapi_base&state=1&connect_redirect=1#wechat_redirect`

                } else {
                    // window.location.href = `https://api.weixin.qq.com/sns/oauth2/access_token?appid=${appid}&secret=SECRET&code=${this.code}&grant_type=authorization_code`


                    // 你自己的业务逻辑
                    //微信公众服务号登录
                    store.dispatch('AccountServ_LoginByWechatServiceAccount', {
                        params: {
                            wechatCode: this.code
                        },
                        urlparams: null
                    }).then((res) => {
                        console.log(res)
                        this.$root.myinfo = res
                        console.log('登陆成功')
                        this.$router.push({
                            name: 'myMenu',
                        })
                    })
                        .catch((err) => {
                            console.log(err)
                            this.$root.openID=err.data.openId
                            this.$router.push({
                                name: 'userRegister',
                            })
                        })
                }
            },
            getUrlCode() { // 截取url中的code方法
                var url = location.search
                // console.log(url)

                this.winUrl = url
                var theRequest = new Object()
                if (url.indexOf("?") != -1) {
                    var str = url.substr(1)
                    var strs = str.split("&")
                    for (var i = 0; i < strs.length; i++) {
                        theRequest[strs[i].split("=")[0]] = (strs[i].split("=")[1])
                    }
                }
                return theRequest
            }
        },

        mounted() {
            //判断是否已登录
            store.dispatch('AccountServ_HasLogined', {
                params: null,
                urlparams: null
            }).then((res) => {
                console.log(res)
                if (res.data===false){
                    this.getCode()
                }else {
                    this.$router.push({
                        name: 'myMenu',
                    })
                }
            })
                .catch((err) => {
                    console.log(err)

                })
            // if (!window.localStorage.getItem('openId')) { // 如果缓存localStorage中没有微信openId，则需用code去后台获取
            //     this.getCode()
            // } else {
            //     // 别的业务逻辑
            // }

        }
    }
</script>

<style scoped>
.onimg{
    text-align: center;
}
</style>
